<template>
<Dialog type="rule" :show="$bus.rule.show" :title="$bus.transify['COMMON_RULE']">
  <template v-slot:dialog-content>
    <div ref="ruleContent" class="rule-content" v-html="$bus.rule.content">
    </div>
  </template>
</Dialog>
</template>

<script>
import Dialog from '@/components/common/Dialog.vue'
export default {
  components: {
    Dialog
  },
  watch: {
    '$bus.rule.show': {
      handler (val) {
        if (!val) {
          this.$refs.ruleContent.scrollTop = 0
        }
      }
    }
  }
}
</script>
<style lang="scss">
.rule-content {
  font-style: italic;
  @include px2res(font-size, 20);
  color: #fff;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  @include px2res(padding, 0, 30, 0, 80);
  * {
    font-family: Arial, Helvetica, sans-serif !important;
    line-height: inherit !important;
  }
}
.rule-content h1,
.rule-content h2,
.rule-content h3,
.rule-content h4,
.rule-content h5,
.rule-content h6 {
  @include px2res(font-size, 36);
  color: #FFDF00;
}
.rule-content p {
  font-family: Arial, Helvetica, sans-serif !important;
  color: #fff;
  font-weight: inherit !important;
}
</style>



// WEBPACK FOOTER //
// src/components/rule/index.vue